import MaintainerHelper from 'features/Maintainer/maintainerHelper';
import { AnimatePresence, motion } from 'framer-motion';
import AppTabs from 'general/components/AppTabs';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import CustomCard from 'general/components/Others/CustomCard';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import useScrollToTop from 'hooks/useScrollToTop';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ChargeHelper from 'features/Charge/chargeHelper';
import BankAccountsView from 'features/ManageDealer/components/BankAccountsView';
import UIHelper from 'general/helpers/UIHelper';
import MaintainerUIHelper from 'features/Maintainer/maintainerUIHelper';
import MaintainerContractListView from 'features/Maintainer/MaintainerContract/components/MaintainerContractListView';
import MaintainerTicketListView from 'features/Maintainer/MaintainerTicket/components/MaintainerTicketListView';

MaintainerDetailView.propTypes = {};

function MaintainerDetailView(props) {
    // ---- params ----
    const { maintainerId, isMaintainerInfo = false } = props;
    const { t } = useTranslation();
    const router = useRouter();
    const maintainerInfoRef = useRef();
    const { user, permissionList } = useSelector((state) => state.auth);
    const adminRole = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
    const [maintainerDetail, setMaintainerDetail] = useState();
    const isMaintainerIndividual = useMemo(() => {
        return maintainerDetail && maintainerDetail?.type === AppConstants.accountType.individual;
    }, [maintainerDetail]);
    const isAdminMaintainer = useMemo(() => {
        if (maintainerDetail) {
            return !maintainerDetail?.parentMaintainerId
        }
        return false;
    }, [maintainerDetail])
    const maintainerBank = useMemo(() => {
        return maintainerDetail?.bankAccounts?.length ? maintainerDetail?.bankAccounts[0] : {}
    }, [maintainerDetail]);

    const [maintainerBankList, setMaintainerBankList] = useState([]);

    const areaTree = useSelector((state) => state.app.areaTree);
    const [maintainerArea, setMaintainerArea] = useState(null);
    const [maintainerParentArea, setMaintainerParentArea] = useState(null);
    useEffect(() => {
        if (areaTree && !_.isEmpty(areaTree) && maintainerDetail) {
            const maintainerAreaId = maintainerDetail?.areaId;
            const maintainerArea = ChargeHelper.Utils.getAreaById([areaTree], maintainerAreaId);
            if (maintainerArea?.typeCode === 'W') {
                setMaintainerArea(maintainerArea);
                setMaintainerParentArea(ChargeHelper.Utils.getAreaById([areaTree], maintainerArea?.parentId));
            } else if (maintainerArea?.typeCode === 'P') {
                setMaintainerParentArea(maintainerArea);
            }
        }
    }, [areaTree, maintainerDetail]);
    const [maintainerWorkArea, setMaintainerWorkArea] = useState(null);
    const [maintainerParentWorkArea, setMaintainerParentWorkArea] = useState(null);
    useEffect(() => {
        if (areaTree && !_.isEmpty(areaTree) && maintainerDetail) {
            const maintainerWorkAreaId = maintainerDetail?.workAddress?.workAreaId;
            const maintainerWorkArea = ChargeHelper.Utils.getAreaById([areaTree], maintainerWorkAreaId);
            if (maintainerWorkArea?.typeCode === 'W') {
                setMaintainerWorkArea(maintainerWorkArea);
                setMaintainerParentWorkArea(ChargeHelper.Utils.getAreaById([areaTree], maintainerWorkArea?.parentId));
            } else if (maintainerWorkArea?.typeCode === 'P') {
                setMaintainerParentWorkArea(maintainerWorkArea);
            }
        }
    }, [areaTree, maintainerDetail]);

    useEffect(() => {
        if (adminRole || isMaintainerInfo) {
            handleGetMaintainerBankList();
        }
    }, [maintainerId, adminRole, isMaintainerInfo]);

    const handleGetMaintainerBankList = async () => {
        const res = await MaintainerHelper.API.requestGetMaintainerBankList({ agencyId: maintainerId });
        setMaintainerBankList(res);
    };

    const hash = router?.location?.hash;
    const [selectedTab, setSelectedTab] = useState('Danh sách hợp đồng');
    const tabs = useMemo(() => {
        if (isMaintainerInfo) {
            return ['Danh sách hợp đồng', 'Tài khoản ngân hàng'].reverse();
        } else {
            return ['Danh sách hợp đồng', 'Lịch sử hoạt động', 'Tài khoản ngân hàng'].reverse();
        }
    }, [t, isMaintainerInfo]);

    useEffect(() => {
        if (hash === '#contract-list') setSelectedTab('Danh sách hợp đồng');
        if (hash === '#action-history') setSelectedTab('Lịch sử hoạt động');
        if (hash === '#bank-accounts') setSelectedTab('Tài khoản ngân hàng');
    }, [hash]);
    const getMaintainerDetail = (id) => {
        MaintainerHelper.API.requestGetMaintainerDetail(id).then((data) => {
            if (data && Object.keys(data)?.length > 0) {
                setMaintainerDetail(data);
            } else {
                router.navigate(-1);
            }
        });
    };

    useEffect(() => {
        getMaintainerDetail(maintainerId);
    }, [maintainerId]);


    const contractListView = useMemo(() => {
        return <MaintainerContractListView maintainerId={maintainerId} onRefresh={() => getMaintainerDetail(maintainerId)} />;
    }, [maintainerId]);

    const actionHistoryListView = useMemo(() => {
        return <MaintainerTicketListView maintainerUserId={maintainerDetail?.users?.[0]?.userId} hasAppTab={true} />
    }, [maintainerDetail])

    const bankAccountsView = useMemo(() => {
        return (
            <BankAccountsView
                agencyId={maintainerId}
                agencyDetail={maintainerDetail}
                banksList={maintainerBankList}
                getAgencyBankList={handleGetMaintainerBankList}
            />
        );
    }, [maintainerId, maintainerDetail, maintainerBankList]);

    // ---- methods ----

    const handleShowEditAgency = (row) => {
        router.navigate(`edit`);
    };

    useScrollToTop();

    const handleSelectedTab = (newTab) => {
        if (selectedTab === newTab) return;
        if (newTab === 'Danh sách hợp đồng') {
            router.navigate('#contract-list');
        }
        if (newTab === 'Lịch sử hoạt động') {
            router.navigate('#action-history');
        }
        if (newTab === 'Tài khoản ngân hàng') {
            router.navigate('#bank-accounts');
        }
        setSelectedTab(newTab);
    };

    const MaintainerInfo = () => {
        return (
            <div
                className="row m-0 position-relative p-3 bg-white rounded-lg"
                style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    boxShadow: '0px 7px 8px -3px #0000000D',
                }}
            >
                <div className="d-flex px-0 align-items-start w-100">
                    <div className="d-flex align-items-center w-95">
                        <img
                            className="rounded-circle"
                            src={
                                (() => {
                                    const ownerUser = maintainerDetail?.users?.find(
                                        user => user?.email === maintainerDetail?.email
                                    );
                                    return ownerUser?.avatar
                                        ? Utils.getFullUrl(ownerUser.avatar)
                                        : AppResource.icons.avatar.default;
                                })()
                            }
                            style={{
                                width: 44,
                            }}
                        />
                        <div className="d-flex flex-column ml-3 w-100">
                            <div className="d-flex align-items-start gap-2" style={{ overflow: 'hidden' }}>
                                <span
                                    // className="font-weight-bolder text-ellipsis-2-lines"
                                    style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}
                                >
                                    {maintainerDetail?.name}
                                </span>

                                <span className="min-w-100px pt-1">
                                    <KTLabel
                                        text={t(`agencyStatus_${maintainerDetail?.status}`)}
                                        isInline={true}
                                        size={KTLabelSize.medium}
                                        additionalClassName={`label-light-${MaintainerHelper.Utils.getMaintainerStatusColor(
                                            maintainerDetail?.status
                                        )}`}
                                    />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex gap-3 justify-content-end ml-auto">
                        <VITableRowDropDown
                            toggleElement={
                                <a
                                    href="#"
                                    className="btn btn-sm btn-clean btn-icon h-45px w-45px hover-opacity-60"
                                    style={{ backgroundColor: AppColors.gray[200] }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                    }}
                                >
                                    <i
                                        className="fa-solid fa-ellipsis"
                                        style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                    />
                                </a>
                            }
                            menuItem={[
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-bolt"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Kích hoạt tài khoản',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmAcceptMaintainer(maintainerDetail, () => {
                                            getMaintainerDetail(maintainerId);
                                        });
                                    },
                                    show: maintainerDetail?.status === 'REGISTERED',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-pen-to-square"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Chỉnh sửa',
                                    click: () => {
                                        handleShowEditAgency(maintainerDetail);
                                    },
                                    show: (!maintainerDetail?.numberOfSignedContracts || adminRole || isMaintainerInfo),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-square"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Ngừng hoạt động',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmStopMaintainer(maintainerDetail, () => {
                                            getMaintainerDetail(maintainerId);
                                        });
                                    },
                                    show: adminRole && maintainerDetail?.status === 'NORMAL',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-play"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Khôi phục hoạt động',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmActiveMaintainer(maintainerDetail, () => {
                                            getMaintainerDetail(maintainerId);
                                        });
                                    },
                                    show: adminRole && maintainerDetail?.status === 'SUSPENDED',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-file-contract"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Tạo hợp đồng KTV',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmCreateContractWithMaintainer(maintainerDetail, () => { });
                                    },
                                    show: adminRole &&
                                        maintainerDetail?.status !== 'REGISTERED'
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-lock`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Đặt lại mật khẩu',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmChangeMaintainerPassword(maintainerDetail, () => {
                                            getMaintainerDetail(maintainerId);
                                        });
                                    },
                                    show: adminRole,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-trash-can`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Xóa kỹ thuật viên',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmDeleteMaintainer(maintainerDetail, () => {
                                            getMaintainerDetail(maintainerId);
                                        });
                                    },
                                    show: adminRole,
                                },
                            ]}
                            singleBtnBgColor={AppColors.gray[200]}
                        />
                    </div>
                </div>

                <div
                    className="my-4"
                    style={{
                        borderTop: `1px dashed ${AppColors.gray[300]}`,
                    }}
                />

                {/* thong tin KTV */}
                <div className="col-xl-12 col-lg-12 col-md-12 d-flex flex-column px-0 ">
                    <div className=" d-flex flex-lg-row flex-column flex-wrap">
                        <>
                            <div className="col-xl-6 p-0 pr-xl-3 pl-0 pr-0 my-1 d-flex flex-column gap-3">
                                {MaintainerUIHelper.buildAccountInfoCard(maintainerDetail, isMaintainerIndividual)}
                                {MaintainerUIHelper.buildWorkAddressCard(maintainerDetail, maintainerParentWorkArea, maintainerWorkArea)}

                                {isMaintainerIndividual && MaintainerUIHelper.buildEKYCInfoCard(maintainerDetail, () => getMaintainerDetail(maintainerId))}

                                {isMaintainerIndividual && MaintainerUIHelper.buildHsmAgreementCard(maintainerDetail)}
                            </div>

                            <div className="col-xl-6 p-0 my-1 d-flex flex-column gap-3">
                                {MaintainerUIHelper.buildOtherInfoCard(maintainerDetail, maintainerParentArea, maintainerArea, maintainerBank, isMaintainerIndividual, adminRole, isMaintainerInfo)}

                                {MaintainerUIHelper.buildDocumentInfoCard(maintainerDetail, isMaintainerIndividual)}

                                {!isMaintainerIndividual && MaintainerUIHelper.buildHsmAgreementCard(maintainerDetail)}
                            </div>
                        </>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div>
            <div className={``}>
                {/* thong tin KTV */}
                <CustomCard
                    showHeader={false}
                    additionalClassName="rounded-lg overflow-hidden mx-4"
                    bgTransparent={true}
                    showBorder={false}
                    body={
                        <div className="d-xl-flex d-lg-flex">
                            <div
                                className="col-12 p-0 h-100"
                                ref={maintainerInfoRef}
                            >
                                {/* thong tin KTV */}
                                <MaintainerInfo />
                            </div>
                        </div>
                    }
                />

                {/* table */}
                <div className=''>
                    {tabs?.length > 1 && (
                        <div className="px-4">
                            <AppTabs tabs={tabs} activeTab={selectedTab} handleClick={handleSelectedTab} />
                        </div>
                    )}
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={selectedTab}
                            initial={{ y: 10, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            exit={{ y: -10, opacity: 0 }}
                            transition={{ duration: 0.2 }}
                        >
                            {selectedTab == 'Danh sách hợp đồng' && <div>{contractListView}</div>}
                            {selectedTab == 'Lịch sử hoạt động' && <div className=''>{actionHistoryListView}</div>}
                            {selectedTab == 'Tài khoản ngân hàng' && <div className='mx-4'>{bankAccountsView}</div>}
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>
        </div>
    );
}

export default MaintainerDetailView;
